export default {
    // 获取数据
}